<template>
  <div class="">
    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 4">
          <a href="" @click.prevent="previous">Board</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="active === 2">Task View</el-breadcrumb-item>
        <el-breadcrumb-item v-if="active === 3">Profile</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-form v-if="active === 1">
      <div class="card card-with-shadow border-0" :active="{ active }">
        <div
          class="card-body position-relative"
          style="padding: 1rem; min-height: 400px"
          :class="{ 'loading-opacity': kanbanViewLoader }">
          <app-overlay-loader v-if="kanbanViewLoader" />

          <div
            v-else
            class="kanban-wrapper custom-scrollbar overflow-auto"
            style="min-height: 400px"
            :class="{
              'justify-content-center align-items-center':
                !kanbanViewData.length,}">
            <template v-if="kanbanViewData.length">
              <div
                v-for="(stage, index) in kanbanViewData"
                :key="'kanban-view-' + index"
                class="kanban-column">
                <div class="p-3 mb-2 stage-header">
                  <div style="display: flex; justify-content: space-between">
                    <h6>{{ stage.name }}</h6>
                    <app-icon name="tag" :color="stage.color_code" />
                  </div>

                  <div
                    class="
                      text-muted
                      d-flex
                      flex-wrap
                      align-items-center
                      stage-information">
                    <span>{{ stage["tasks"].length + " " + $t("tasks") }}</span>
                  </div>
                </div>

                <draggable
                  class="kanban-draggable-column"
                  :list="stage['tasks']"
                  @change="changedPosition($event, stage.id)"
                  group="deals">
                  <div
                    class="card card-with-shadow mb-2 border-0 draggable-item"
                    v-for="(element, index) in stage['tasks']"
                    :key="index">
                    <div
                      class="card-body font-size-90"
                      :style="
                        element.task_endorsement_request.length > 0 && {
                          borderTop:
                            'solid 1px var(--side-bar-dark-text-color)',}">
                      <div class="row">
                        <div class="col-10">
                          <div class="media d-flex align-items-start">
                            <app-avatar
                              :title="element.title"
                              class="mr-2"
                              avatar-class="avatars-w-20"
                              :img="element.img ? element.img : ''"
                              :alt-text="$t('not_found')"/>

                            <div
                              class="
                                media-body
                                d-flex
                                justify-content-start">
                                <!-- v-if="
                                  element.due_date > currentDate &&
                                  element.due_date != null" -->
                              <a
                                href="#"
                                @click="viewItem(element.id)"
                                style="">
                                {{ element.title }}
                              </a>
                              <!-- <p
                                class="mb-0"
                                style="color: var(--side-bar-dark-text-color)"
                                v-else>
                                {{ element.title }}
                              </p> -->
                            </div>
                          </div>
                          <div class="text-muted d-flex align-items-start mb-2">
                            <div class="media-body d-flex justify-content-start ml-4">
                              <small>{{ element.due_date }}</small>
                            </div>
                          </div>
                          <div class="text-muted d-flex align-items-start mb-primary">
                            <div class="media-body d-flex justify-content-start ml-4">
                              <div v-if="element.task_endorsement_request.length > 0" class="d-flex">
                                <div
                                  v-for="(endorsement, y) in element.task_endorsement_request" :key="y">
                                  <div
                                    v-if="
                                      endorsement.task_id == element.id &&
                                      element.id &&
                                      endorsement.status == 0">
                                    <i
                                      class="fa fa-star"
                                      style="color: red"
                                    ></i>
                                  </div>
                                  <div v-else>
                                    <div
                                      v-if="element.task_endorsement.length > 0">
                                      <div
                                        v-for="(endorse, x) in element.task_endorsement" :key="x">
                                        <el-tooltip
                                          v-if="
                                            endorse.task_id == element.id &&
                                            endorsement.status == 1 &&
                                            endorse.endorsed_by ==
                                              endorsement.user_id"
                                          placement="top"
                                          :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                          :content="endorse.user.full_name">
                                          <i
                                            class="fa fa-star"
                                            style="
                                              cursor: pointer;
                                              color: green;"
                                          ></i>
                                        </el-tooltip>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-2">
                          <div
                            class="dropdown options-dropdown d-inline-block"
                            :class="{ tour_id: index === 0 }"
                          >
                            <button
                              type="button"
                              class="btn-option btn"
                              data-toggle="dropdown"
                              :title="$t('actions')"
                            >
                              <app-icon name="more-vertical" />
                            </button>
                            <div
                              class="
                                dropdown-menu dropdown-menu-right
                                py-2
                                mt-1
                              "
                            >
                            <div>
                              <a
                                v-if="element.created_by == userRole.id"
                                class="dropdown-item px-4 py-2"
                                @click="editItem(element.id)"
                                href="#">
                                {{ $t("edit") }}
                              </a>
                            </div>
                              <a
                                class="dropdown-item px-4 py-2"
                                @click="viewItem(element.id)"
                                href="#"
                              >
                                {{ $t("view") }}
                              </a>
                              <!-- <div v-if="userRole.role == 'App Admin'">
                                <a
                                  class="dropdown-item px-4 py-2"
                                  @click="endorseItem(element.id)"
                                  href="#"
                                >
                                  {{ $t("endorsement") }}
                                </a>
                              </div> -->
                              <!-- <div v-if="userRole.role != 'App Admin'">
                                <a
                                  v-for="(
                                    request, x
                                  ) in element.task_endorsement_request"
                                  :key="x"
                                  class="dropdown-item px-4 py-2"
                                  @click="endorseItem(element.id)"
                                  href="#"
                                >
                                  <template
                                    v-if="userRole.id == request.user_id"
                                  >
                                    {{ $t("endorsement") }}
                                  </template>
                                </a>
                              </div> -->

                              <!-- <a
                                v-if="userRole.role == 'App Admin'"
                                class="dropdown-item px-4 py-2"
                                @click="endorseRequestItem(element.id)"
                                href="#"
                              >
                                {{ $t("send_endorsement_request") }}
                              </a>
                              <a
                                v-if="userRole.role == 'App Admin'"
                                class="dropdown-item px-4 py-2"
                                @click.prevent="openReminderModal(element.id)"
                                href="#"
                              >
                                {{ $t("reminder") }}
                              </a> -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-10">
                          <div class="text-muted d-flex align-items-center justify-content-between"
                                v-for="(i, index) in element['users']" :key="index">
                            <div class="media d-flex align-items-center"
                                v-if="boardType != 'portal_board'">
                              <app-avatar
                                class="mr-2"
                                avatar-class="avatars-w-20"
                                :img="''"
                                :alt-text="$t('not_found')"
                              />
                              <div class="media-body">
                                {{ i.full_name }}
                              </div>
                            </div>
                            <div class="media d-flex align-items-center" v-else-if="i.role[0].name == 'Buyer' || i.role[0].name == 'Supplier'">
                                <app-avatar
                                    :title="i.role[0].name"
                                    class="mr-2"
                                    avatar-class="avatars-w-20"
                                    :img="''"
                                    :alt-text="$t('not_found')"
                                />
                                <div class="media-body">
                                    <a href="#"
                                        style="color: var(--side-bar-dark-text-color)"
                                        @click="profile(i.id)">
                                        {{ i.full_name }}
                                    </a>
                                </div>
                            </div>
                          </div>
                         </div>
                        <div class="col-2" v-if="element.task_forms.length > 0">
                          <div class="text-muted d-flex align-items-start">
                            <div
                              class="media-body d-flex justify-content-start"
                            >
                              <el-tooltip
                                placement="top"
                                :effect="
                                  theemMode.darkMode == true ? 'light' : 'dark'
                                "
                                content="Completed Questionnaire"
                              >
                                <small>
                                  {{ success_form_count[element.id] }}/{{
                                    element.task_forms.length
                                  }}
                                </small>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </draggable>
                <div class="draggable-action-wrapper" v-if="boardType != 'portal_board'">
                  <button
                    class="btn btn-stage-action shadow"
                    slot="footer"
                    data-toggle="modal"
                    @click.prevent="openAddModal(stage.id)">
                    <app-icon name="plus" class="mr-1" />
                    {{ $t("add") }}
                  </button>
                </div>
              </div>
            </template>
            <template v-else>
              <app-empty-data-block
                :message="$t('nothing_to_show_here')"
              ></app-empty-data-block>
            </template>
          </div>
        </div>
      </div>
    </el-form>

    <el-form v-if="active === 2">
      <div class="remove-title">
        <task-mytask-view
          :id="id"
          :afterSubmitDone="reloadAllState"
          :remove="classRemove"
          :active="{ active }"
        ></task-mytask-view>
      </div>
    </el-form>

    <el-form v-if="active === 3">
      <my-profile :id="user_id" :remove="classRemove"></my-profile>
    </el-form>

    <!--Add Edit Modal-->
    <site-task-add-modal
      v-if="isTaskModalActive"
      :stage_id="selectedStageId"
      :job_id="jobId"
      :selected-url="selectedUrlOfThisScope"
      @afterSubmitDone="reloadAllState"
      @close-modal="closeAddModal"
    />
    <!--Delete Modal-->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="task-delete"
      @confirmed="confirmed"
      @cancelled="canceled"
    />

    <!--Task endorsement Request Modal-->
    <task-endorsement-request-modal
      v-if="isTaskRequestModalActive"
      modal-id="endorsement-request-send-Modal"
      :taskId="task_id"
      :type="boardType"
      @afterSubmitDone="reloadAllState"
      @close-modal="isTaskRequestModalActive = false"
    />

    <!--Task endorsement Modal-->
    <task-endorse
      v-if="isTaskEndorseModalActive"
      modal-id="endorse-Modal"
      :taskId="task_id"
      @afterSubmitDone="reloadAllState"
      @close-modal="isTaskEndorseModalActive = false"
    />

<!--Task Reminder Modal-->
    <task-reminder
      v-if="isTaskReminderModalActive"
      modal-id="reminder-Modal"
      :taskId="task_id"
      @afterSubmitDone="reloadAllState"
      @close-modal="isTaskReminderModalActive = false"
    />

    <task-mytaskmodal
      v-if="isTaskEditModalActive"
      :stage-id="selectedStageId"
      :afterSubmitDone="reloadAllState"
      @close-modal="closeTaskEditModal"
      :id="taskId"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import draggable from "vuedraggable";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import {
  TASKS,
  JOB_STAGES,
  SEARCH_SELECT_COMPANY_NAME,
  COMPANY_JOB_SITE_TASK_SHOW,
} from "../../../../Config/ApiUrl";
import moment from "moment";

export default {
  name: "WoekspaceBoard",
  components: { draggable},
  mixins: [FormMixin],
  extends: CoreLibrary,
  data() {
    return {
      // message: '',
      jobId: this.$attrs['props'].jobId,
      user_id: 0,
      boardType: "",
      success_form_count: [],
      currentDate: "",
      classRemove: true,
      invoice: {},
      id: 0,
      active: 1,
      task_id: 0,
      endorsement: {},
      user: [],
      url: "",
      inputs: {},
      select_compnay: "",
      companies: [],
      tital: "",
      isTaskEndorseModalActive: false,
      isTaskReminderModalActive: false,
      isTaskEditModalActive: false,
      kanbanViewLoader: false,
      deleteLoader: false,
      isTaskModalActive: false,
      deleteConfirmationModalActive: false,
      kanbanViewData: [],
      selectedUrlOfThisScope: null,
      selectedStageId: null,
      deletedTaskId: null,
      isTaskRequestModalActive: false,
      roleCheck: true,
      steps: [
        {
          target: ".tour_id", // We're using document.querySelector() under the hood
          content: `Click on Actions to edit, view or delete your task`,
          params: {
            enableScrolling: false,
          },
        },
      ],
      status:[
        {id:'completed', value:'Completed'},
        {id:'incomplete', value:'Incomplete'},
      ],
      select_status:'',
    };
  },
  created() {
    this.reloadKanbanView();
  },
  mounted() {
    // this.searchAndSelectFilterOptions();
    this.currentDate = moment(new Date()).format("YYYY-MM-DD");
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },

    removeClass() {
      if (this.active == 2) {
        $(".remove-title .remove-wrapper").removeClass("content-wrapper");
      }
    },
  },
  watch: {
    select_compnay() {
      this.reloadKanbanView();
    },
    select_status() {
      this.reloadKanbanView();
    },
  },
  methods: {
    previous() {
      this.active = 1;
      this.$store.commit('deleteSharedData',"showFormActions");
      this.reloadKanbanView();
    },
    startTour() {
      this.$tours["myTour"].start();
    },
    // searchAndSelectFilterOptions() {
    //   this.axiosGet(SEARCH_SELECT_COMPANY_NAME).then((response) => {
    //     this.companies = response.data;
    //   });
    // },

    closeTaskEditModal() {
      // $("#my_task_modal").modal("hide");
      this.isTaskEditModalActive = false;
      this.selectedUrlOfThisScope = "";
    },
    reloadKanbanView() {
      this.$store.commit('updateSharedData', {index: "companyId", newValue: this.select_compnay})
      this.kanbanViewLoader = true;

      this.url = JOB_STAGES + "?company_id=" + this.$attrs['props'].companyId + '&job_id=' +this.$attrs['props'].jobId;

      this.axiosGet(this.url)
        .then((res) => {
          this.active = 1;
          this.kanbanViewData = res.data;
          this.invoice = res.data[0].invoice;

          let stage_task = res.data;
          if (stage_task.length > 0) {
            var sum = 0;
            stage_task.map((stageTask) => {
              stageTask.tasks.map((taskForm) => {
                taskForm.task_form_status.map((status) => {
                  if (
                    (status.status == 'submitted' || status.status == 'approved') &&
                        status.task_id == taskForm.id
                  ) {
                    sum += 1;
                  }
                });
                let index = taskForm.id;
                this.success_form_count[index] = sum;
                sum = 0;
              });
            });
          }
        })
        .finally(() => (this.kanbanViewLoader = false));
    },
    openAddModal(stageId) {
      this.selectedUrlOfThisScope = "";
      this.selectedStageId = stageId;
      this.isTaskModalActive = true;
    },
    closeAddModal() {
      $('#workspace-job-site-add-modal').modal('hide');
      this.isTaskModalActive = false;
      this.reloadAllState();
    },
    reloadAllState() {
      this.selectedUrlOfThisScope = "";
      this.selectedStageId = null;
      this.isTaskModalActive = false;
      this.reloadKanbanView();
    },
    changedPosition(event, id) {
      if (!this.isUndefined(event["added"])) {
        let taskId = event["added"].element.id;
        this.axiosPatch({
          url: `${TASKS}/${taskId}`,
          data: { stage_id: id },
        });
      }
    },
    editItem(taskId) {
      this.selectedUrlOfThisScope = `${COMPANY_JOB_SITE_TASK_SHOW}/${taskId}`;
      this.isTaskModalActive = true;
    },
    viewItem(taskId) {
      this.id = taskId;
      this.active = 2;
    },
    profile(id) {
      this.active = 3;
      this.user_id = id;
    },
    deleteItem(taskId) {
      this.deletedTaskId = taskId;
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      this.deleteLoader = true;
      let deleteUrl = `${TASKS}/${this.deletedTaskId}`;
      this.axiosDelete(deleteUrl)
        .then((res) => {
          this.hideDeleteModal();
          this.$toastr.s(res.data.message);
          this.reloadKanbanView();
        })
        .catch((err) => {
          this.hideDeleteModal();
          this.$toastr.e(err.data.message);
        });
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
    canceled() {
      this.deletedTaskId = null;
      this.deleteConfirmationModalActive = false;
    },

    endorseItem(id) {
      this.task_id = id;
      this.isTaskEndorseModalActive = true;
    },
    endorseRequestItem(id) {
      this.task_id = id;
      this.isTaskRequestModalActive = true;
    },
    openReminderModal(task_id){
      this.isTaskReminderModalActive = true;
      this.task_id = task_id;
    },
  },
};
</script>

<style>
.remove-title .hide-title {
  display: none !important;
}
</style>
